const eur0 = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});
const eur2 = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmtEUR = (v) => eur0.format(Number(v || 0));
export const fmtEUR2 = (v) => eur2.format(Number(v || 0));

export const fmtSigned = (v) => {
  const n = Number(v || 0);
  const s = eur0.format(Math.abs(n));
  return n > 0 ? `+${s}` : n < 0 ? `−${s}` : s;
};

const parseLocalDate = (iso) => {
  if (iso instanceof Date) return iso;
  const s = String(iso || "");
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(s);
};

export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  return new Intl.DateTimeFormat("fr-FR").format(parseLocalDate(iso));
};

export const fmtDateLong = (iso) => {
  if (!iso) return "";
  return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long" }).format(parseLocalDate(iso));
};

export const MONTHS_FR = [
  "", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

export const monthLabel = (y, m) => `${MONTHS_FR[m]} ${y}`;
